// TSS vite/04 §"Endpoint paths". baseURL ya incluye /api/v1.
// Unificar duplicados / merge (admin-merge.md · decisión 0129): una ruta por entidad,
// el tipo NO viaja en el body. Permiso <entidad>:admin.

export const mergePaths = {
    merge: (entity) => `admin/${entity}/merge`, // entity ∈ 'animals' | 'clients' | 'farms'
};

// Eliminaciones sensibles. Borrado en cascada de una sesión OPU (admin-aspiration-sessions.md · 0127):
// DELETE con body { confirm: true }. Soft-delete reversible; 409 si hay parto activo aguas abajo.
export const deletionPaths = {
    opuSession: (id) => `admin/aspiration-sessions/${id}`,
};
